import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  signUpContainer: {
    height: '100vh',
    overflow: 'auto',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
  },
  gridContainer: {
    display: 'flex',
  },
  leftSide: {
    height: '100%',
    width: '50%',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  leftSideContent: {
    padding: '35px 70px 30px 190px',
    '@media (max-width: 1024px)': {
      padding: '20px 30px 20px 30px',
    },
    '@media (max-width: 767px)': {
      padding: '25px 5%',
    },
  },
  imgBox: {
    paddingBottom: 85,
    marginLeft: -6,
    '@media (max-width: 767px)': {
      paddingBottom: 35,
    },
  },
  logoIcon: {},
  welcome8vdx: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.warning.contrastText,
  },
  validateForm: {
    paddingTop: 43,
  },
  controllerBox: {
    position: 'relative',
  },
  labelText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    fontWeight: 500,
    marginBottom: 5,
  },
  textValInput: {
    marginBottom: 35,
    width: '100%',
  },
  textSocialInput: {
    marginBottom: 16,
    width: '100%',
  },
  selectedOpt: {
    display: 'flex',
  },
  selectedOptL: {
    width: 115,
  },
  selectedOptR: {
    width: 'calc(100% - 115px)',
    paddingLeft: 15,
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 13,
    position: 'absolute',
    bottom: 15,
    left: 0,
    fontFamily: theme.typography.fontFamily,
  },
  errorUrl: {
    color: theme.palette.error.main,
    fontSize: 13,
    position: 'absolute',
    bottom: -1,
    left: 0,
    fontFamily: theme.typography.fontFamily,
  },
  errorPwd: {
    color: theme.palette.error.main,
    fontSize: 12,
    position: 'absolute',
    bottom: 3,
    left: 0,
    fontFamily: theme.typography.fontFamily,
  },
  errorAlready: {
    color: theme.palette.error.main,
    fontSize: 14,
    position: 'relative',
    marginBottom: 0,
    paddingRight: 5,
    paddingTop: 10,
    fontFamily: theme.typography.fontFamily,
  },
  inputRoot: {
    fontSize: 16,
    width: '100%',
    '&:hover': {
      '&:not(.Mui-disabled)::before': {
        borderBottomColor: theme.palette.primary.light,
      },
    },
  },
  labelRoot: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    letterSpacing: 0.35,
  },
  labelFocused: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    transform: 'translate(0, 1.5px) scale(1)',
  },
  selectValInput: {
    marginBottom: 15,
    width: '115px',
    marginTop: 0,
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      paddingTop: 9,
    },
  },
  signupBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    height: 57,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: '100%',
    fontSize: 16,
    marginTop: 25,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  checkBoxAgree: {
    paddingTop: 18,
  },
  agreeTerms: {
    fontSize: 14,
    letterSpacing: 0.35,
    color: theme.palette.common.black,
    opacity: 0.6,
  },
  termAndCondition: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  termsText: {
    color: theme.palette.error.main,
    fontSize: 13,
    display: 'block',
  },
  tCText: {
    paddingTop: 20,
    color: theme.palette.common.black,
    opacity: 0.6,
  },
  alreadyAcText: {
    color: theme.palette.common.black,
    opacity: 0.6,
    marginBottom: 22,
    marginTop: 30,
    fontSize: 14,
    '@media (max-width: 767px)': {
      marginBottom: 15,
      marginTop: 15,
    },
  },
  signInLink: {
    color: theme.palette.grey.A200,
    cursor: 'pointer',
    opacity: 1,
  },
  copyText: {
    color: theme.palette.grey[200],
    fontSize: 14,
  },
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'inherit',
    alignItems: 'center',
    marginTop: 50,
  },
  referralRegisteredBox: {
    margin: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  errorReferralRegistered: {
    letterSpacing: 0.35,
    color: theme.palette.error.main,
    fontSize: 20,
  },
}));
